import EventEmitter from './EventEmitter.js';

export default class DataSet extends EventEmitter {
  constructor(initialItems) {
    super();
    this._data = new Map();
    this._nextId = 1;
    if (initialItems) this.add(initialItems);
  }

  get length() {
    return this._data.size;
  }

  get(idOrIds) {
    if (idOrIds === undefined || idOrIds === null) {
      return Array.from(this._data.values());
    }
    if (Array.isArray(idOrIds)) {
      return idOrIds.map(id => this._data.get(id)).filter(Boolean);
    }
    return this._data.get(idOrIds) || null;
  }

  getIds() {
    return Array.from(this._data.keys());
  }

  add(items) {
    const arr = Array.isArray(items) ? items : [items];
    const added = [];
    for (let i = 0; i < arr.length; i++) {
      const item = { ...arr[i] };
      if (item.id === undefined || item.id === null) {
        item.id = this._nextId++;
      }
      if (this._data.has(item.id)) continue;
      this._data.set(item.id, item);
      added.push(item.id);
      if (item.id >= this._nextId) this._nextId = item.id + 1;
    }
    if (added.length > 0) {
      this.emit('add', { items: added });
    }
    return added;
  }

  update(items) {
    const arr = Array.isArray(items) ? items : [items];
    const updated = [];
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (item.id === undefined) continue;
      const existing = this._data.get(item.id);
      if (existing) {
        this._data.set(item.id, { ...existing, ...item });
        updated.push(item.id);
      } else {
        this._data.set(item.id, { ...item });
        updated.push(item.id);
        if (item.id >= this._nextId) this._nextId = item.id + 1;
      }
    }
    if (updated.length > 0) {
      this.emit('update', { items: updated });
    }
    return updated;
  }

  remove(ids) {
    const arr = Array.isArray(ids) ? ids : [ids];
    const removed = [];
    for (let i = 0; i < arr.length; i++) {
      const id = typeof arr[i] === 'object' ? arr[i].id : arr[i];
      if (this._data.delete(id)) {
        removed.push(id);
      }
    }
    if (removed.length > 0) {
      this.emit('remove', { items: removed });
    }
    return removed;
  }

  clear() {
    const ids = this.getIds();
    this._data.clear();
    if (ids.length > 0) {
      this.emit('remove', { items: ids });
    }
  }

  forEach(fn) {
    this._data.forEach(fn);
  }
}
